// Copyright (c) Ensho Health, 2021 to present

import { gql } from 'graphql-request';
import { workflowClient } from './client-gql.js';

export async function clinicSetupComplete(clinicId) {
  try {
    if (typeof clinicId === 'string') {
      clinicId = parseInt(clinicId);
    }
    const query = gql`
      mutation clinicSetupComplete($clinicId: Int!) {
        clinicSetupComplete(clinicId: $clinicId, setupComplete: true) {
          ok
          error
        }
      }
    `;
    const variables = { clinicId };
    const response = await workflowClient.request(query, variables);
    return response?.clinicSetupComplete;
  } catch (error) {
    throw error;
  }
}
